import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import OutlineWarningIcon from "../../../svg/outline-warning-icon";

const HappyFlowModal = (props: {
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
}) => {
  return (
    <Modal
      dialogId={ModalId.HAPPY_FLOW_MODAL}
      title="Mark as Completed"
      onClose={props.onClose}
      onSave={props.onSave}
      cancelText="No, Cancel"
      disableSave={props.isLoading}
      saveButtonText={props.isLoading ? "Saving..." : "Yes, Confirm"}
    >
      <div className="flex flex-col items-center justify-center gap-4 py-2">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primaryGray-16">
          <OutlineWarningIcon />
        </div>
        <div className="w-4/5 text-wrap text-center font-normal text-primaryGray-1">
          Are you sure you want to mark the order as complete, this will update
          the status ?
        </div>
      </div>
    </Modal>
  );
};

export default HappyFlowModal;
